export const LIST_USER_EXPORTS = '/productmodels/user-exports/list'
export const LIST_USER_EXPORTS_BY_TYPE = '/productmodels/user-exports/list?onDemandType='
export const GET_USER_EXPORT_METADATA = '/productmodels/metadata/:userExportID'
export const ON_DEMAND_EXPORTS_BOM_VALIDATION = '/on-demand-exports/:userExportID'
export const LIST_VALIDATIONS = '/on-demand-exports/:id/bom-validation'
export const LIST_VALIDATIONS_BASIC = '/on-demand-exports/:id/basic'
export const ON_DEMAND_EXPORTS_TEST_CASES_VALIDATION = '/test-cases/:testCaseId/validations'
export const ON_DEMAND_EXPORTS_UNUSABLE_CHOICES_VALIDATION = '/on-demand-exports/:productModelID/unusable-choices'
export const GET_AUTOCOMPLETE_SUGGESTION = '/domain/autocomplete'
export const GET_AUTOCOMPLETE_SUGGESTION_PASTED = '/domain/autocomplete/batch'
export const AUTOCOMPLETE_LOGIC_EXPRESSIONS = '/domain/logic-expressions'
